import React, { useContext } from 'react';
import { useQuery } from '@apollo/client';
//import { ConfigContext } from '../../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
import {
  Modal,
  DataGridGroup,
  Text,
  useResponsiveParams,
} from 'quanta-ui';

// import Loading from '../../../../../../lib/layout/loading';
// import Error from '../../../../../../lib/layout/error';

import { Loading } from 'quanta-flows/modules/layout';
import { Error } from 'quanta-flows/modules/layout';

import { QUERY_STATE } from '../../queries';

//import CurrencyFormater from '../../../../../../lib/intl/CurrencyFormater';

import { CurrencyFormater } from 'quanta-flows';

export default function ModalViewBreakup({
  showViewBreakup,
  setShowViewBreakup,
  selectedPlanTypeView,
  product_name,
  genderList,
}) {
  let repeatForMobile = 2;
  let repeatForDesktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: repeatForMobile,
    for_desktop: repeatForDesktop,
  });
  const { branding } = useContext(QuantaConfigContext);
  const { loading, error, data } = useQuery(QUERY_STATE);

  const { healthQuote, healthPlans } = data;

  const selectedPlan = healthPlans.plans.find(
    (plan) => plan.name === selectedPlanTypeView,
  );
 ////console.log('40_selectedPlan',selectedPlan)
  const resolveGender = (code) =>
    genderList.find(
      (gender) => gender.code.toLowerCase() === code.toLowerCase(),
    ).value;

  const display_data = [
    {
      grid_data: [
        {
          colSpan: repeat,
          text: (
            <Text type="subheading" severity="info">
              {product_name}, {selectedPlanTypeView}
            </Text>
          ),
        },
      ],
    },
    {
      grid_data: [
        //{ label: 'Cover Type', text: healthQuote.cover.type },
        {
          label: 'Sum Insured',
          text: CurrencyFormater(healthQuote.cover.sum_insured),
        },
        { label: 'Tenure', text: healthQuote.cover.tenure },
      ],
    },
    {
      grid_data:
        selectedPlan && selectedPlan.premium
          ? [
              {
                text: <Text type="normal"></Text>,
                severity: 'info',
                colSpan: repeat === repeatForMobile ? 1 : 2,
              },
              {
                text: (
                  <Text
                    type="normal"
                    className="flex justify-end mr-4"
                  >
                    Premium ({branding.currency})
                  </Text>
                ),
                severity: 'info',
                colSpan: 1,
              },
              ...selectedPlan.premium.breakup
                .map((mem, idx) => {
                  return [
                    {
                      text: 'Total Amount',
                      colSpan: repeat === repeatForMobile ? 1 : 2,
                      type: 'normal',
                    },
                    {
                      text: (
                        <Text className="flex justify-end mr-4">
                          {CurrencyFormater(mem.premium, false)}
                        </Text>
                      ),
                      colSpan: 1,
                      type: 'normal',
                    },
                  ];
                })
                .reduce((b, a) => [...b, ...a]),
              // {
              //   text: (
              //     <Text type="normal">
              //       {repeat === repeatForMobile
              //         ? 'Base Premium'
              //         : 'Total Base Premium'}
              //     </Text>
              //   ),
              //   severity: 'info',
              //   colSpan: repeat === repeatForMobile ? 1 : 2,
              // },
              // {
              //   text: (
              //     <Text
              //       type="normal"
              //       className="flex justify-end mr-4"
              //     >
              //       {CurrencyFormater(
              //         selectedPlan && selectedPlan.premium
              //           ? selectedPlan.premium.basePremium
              //           : 0,
              //         false,
              //       )}
              //     </Text>
              //   ),
              //   severity: 'info',
              //   colSpan: 1,
              // },
            ]
          : [
              {
                text: <Text type="title"></Text>,
                colSpan: repeat === repeatForMobile ? 1 : 2,
                severity: 'info',
              },
              {
                text: <Text type="title">Premium</Text>,
                colSpan: 1,
                severity: 'info',
              },
            ],
    },
    // {
    //   grid_data: [
    //     {
    //       text: <Text type="normal">Discount</Text>,
    //       severity: 'info',
    //       colSpan: repeat === repeatForMobile ? 1 : 2,
    //     },
    //     {
    //       text: (
    //         <Text type="normal" className="flex justify-end mr-4">
    //           {CurrencyFormater(
    //             selectedPlan && selectedPlan.premium
    //               ? selectedPlan.premium.loadingDiscount
    //               : 0,
    //             false,
    //           )}
    //         </Text>
    //       ),
    //       severity: 'info',
    //       colSpan: 1,
    //     },
    //   ],
    // },
    {
      grid_data: [
        {
          text: <Text type="normal">Net Premium</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                selectedPlan && selectedPlan.premium
                  ? selectedPlan.premium.netPremium
                  : 0,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="normal">GST/Tax</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="normal" className="flex justify-end mr-4">
              {CurrencyFormater(
                selectedPlan && selectedPlan.premium
                  ? selectedPlan.premium.gst
                  : 0,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
        {
          text: <Text type="subheading">Total Premium</Text>,
          severity: 'info',
          colSpan: repeat === repeatForMobile ? 1 : 2,
        },
        {
          text: (
            <Text type="subheading" className="flex justify-end mr-4">
              {CurrencyFormater(
                selectedPlan && selectedPlan.premium
                  ? selectedPlan.premium.totalPremium
                  : 0,
                false,
              )}
            </Text>
          ),
          severity: 'info',
          colSpan: 1,
        },
      ],
    },
  ];
//console.log(`breakup page over`)
  return loading ? (
    <Loading />
  ) : error ? (
    <Error />
  ) : selectedPlan ? (
    <div className="text-black font-normal">
      <Modal
        display={showViewBreakup}
        size="small"
        title="Premium Breakup for Quote"
        onClose={(e) => setShowViewBreakup(false)}
      >
        <DataGridGroup
          data={display_data}
          textType="normal"
          severity="none"
          repeat={repeat}
          spaceY={4}
        />
      </Modal>
    </div>
  ) : (
    <div></div>
  );
}
